export const theme = {
  colors: {
    // Base
    background: '#080c14',
    surface: '#10161f',
    surfaceLight: '#1a2233',
    border: '#1e2a3a',

    // Text
    textPrimary: '#dce6f0',
    textSecondary: '#8899aa',
    textDim: '#6b8090',
    textAccent: '#00ff88',

    // Map elements — roads brighter for readability, buildings darker for contrast
    buildingFill: '#0c1018',
    buildingStroke: '#182030',
    streetMajor: '#7090a8',
    streetMinor: '#506878',
    streetResidential: '#3e5565',
    streetFootpath: '#2a5040',
    waterFill: '#081020',
    waterStroke: '#142444',
    parkFill: '#0d1a14',

    // Transit
    transitSubway: '#ff4444',
    transitBus: '#44aaff',
    transitTram: '#ffaa44',
    transitStop: '#ffffff',

    // Game elements
    playerMarker: '#44aaff',
    agentMarker: '#ff3344',
    signalPlayer: '#44aaff',
    signalAgent: '#ff3344',
    signalDecoy: '#ffaa44',
    itemPickup: '#ffdd44',
    pickupWeapon: '#ff5050',
    pickupGadget: '#44cc66',
    pickupMixed: '#ffdd44',
    pickupLockpick: '#cc8844', // brass/copper — reads as key/tool at a glance
    pickupScanner: '#44ccff',  // cyan — reads as signal/electronics
    extractionLow: '#88ddaa',
    extractionMed: '#ddcc77',
    extractionHigh: '#dd8866',
    visionCone: '#00ff8840',

    // UI accent
    accentGreen: '#00ff88',
    accentRed: '#ff3344',
    accentBlue: '#44aaff',
    accentYellow: '#ffdd44',
    accentOrange: '#ffaa44',
  },
  fonts: {
    mono: "'JetBrains Mono', 'Fira Code', 'Courier New', monospace",
    display: "'JetBrains Mono', monospace",
  },
} as const;

export type Theme = typeof theme;
